import AppConstants from '../../../../config/app.constants';

class CountVariancesController {
    /*@ngInject*/

    constructor(DateUtil, $translate, $q, User, Modal, TimezoneList, SetupService, UsersService, UserBranchService, CountVariancesService, DataCounter, $state, Navigation, $rootScope) {
        this.DateUtil = DateUtil;
        this.$translate = $translate;
        this.User = User;
        this.Modal = Modal;
        this.TimezoneList = TimezoneList;
        this.SetupService = SetupService;
        this.UsersService = UsersService;
        this.UserBranchService = UserBranchService;
        this.CountVariancesService = CountVariancesService;
        this.DataCounter = DataCounter;
        this.$state = $state;
        this.$q = $q;
        this.Navigation = Navigation;
        this.$rootScope = $rootScope;

        this.model = {
            timezoneList: this.TimezoneList.getTimezoneList(),
            countVariancesObj: {
                totalRecords: 0,
                results: []
            },
            pagination: {
                page: 1,
                total: 0,
                pageLimit: 10,
                maxPages: 10
            },
            dateRangeOptions: {
                startDate: null,
                endDate: null,
            },
            loggedInUser: User.getUser().id,
            branch: User.getUser().branchId,
            userBranchList: [],
            timezone: null,
            sortColumn: "countedAt",
            reverseSort: true,
            loadCountVariances: false,
            isExporting: false
        };
        this.$rootScope.$broadcast('routeChange', '/app/branch-management/count-variances');
    }

    $onInit() {
        this.model.loading = true;
        this.$q.all([
            this.SetupService.get(this.model.branch),
            this.UsersService.getUserFieldData(this.model.loggedInUser),
            this.UserBranchService.getUserBranches(this.model.loggedInUser),
        ])
            .then((data) => {
                this.model.setupDetails = data[0];
                this.model.userDetails = data[1];
                this.model.userBranchList = data[2].results;
                this.model.vaultDate = this.DateUtil.convertToDate(this.model.setupDetails.currentVaultDate);
                this.model.timezone = (this.model.userDetails && this.model.userDetails.timezone) ? this.model.userDetails.timezone : moment.tz.guess();

                this.model.userBranchList.filter((branch) => {
                    if (branch.branchId == this.model.setupDetails.branchId) {
                        branch.ticked = true;
                    }
                })

                this.loadDateRangePicker(this.model.vaultDate, this.model.dateRangeOptions, 'dateRange');
                this.model.dateRangeOptions.startDate = moment(this.model.vaultDate).subtract(30, 'days').format('YYYY-MM-DD 00:00:00');
                this.model.dateRangeOptions.endDate = moment(this.model.vaultDate).add(14, 'days').format('YYYY-MM-DD 23:59:59');

                this.loadData();
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                this.model.loading = false;
            })
    }

    loadDateRangePicker(date, dateRangeOption, modelVal) {
        let currentVaultDate = moment(date).format() || moment();
        this.model[modelVal] = {
            autoApply: true,
            eventHandlers: {
                'apply.daterangepicker': () => {
                    this.loadData();
                }
            },
            ranges: {
                'Running 45 Days': [
                    moment(currentVaultDate).subtract(30, 'days').format('YYYY-MM-DD HH:mm:ss'),
                    moment(currentVaultDate).add(14, 'days').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Today': [
                    moment(currentVaultDate).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                    moment(currentVaultDate).endOf('day').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Current Week': [
                    moment(currentVaultDate).startOf('week').format('YYYY-MM-DD HH:mm:ss'),
                    moment(currentVaultDate).endOf('week').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Current Month': [
                    moment(currentVaultDate).startOf('month').format('YYYY-MM-DD HH:mm:ss'),
                    moment(currentVaultDate).endOf('month').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Current Year': [
                    moment(currentVaultDate).startOf('year').format('YYYY-MM-DD HH:mm:ss'),
                    moment(currentVaultDate).endOf('year').format('YYYY-MM-DD HH:mm:ss')
                ]
            }
        }
    }

    loadData() {
        this.model.pagination.page = 1;
        this.getCountVariances();
    }

    getCountVariances() {
        setTimeout(() => {
            const startDate = this.getStartDate();
            const endDate = this.getEndDate();
            const branches = this.model.selectedBranch.map((branchObj) => branchObj.branchId);

            this.model.loadCountVariances = true;
            this.CountVariancesService.countVariances(this.model.searchText, branches, startDate, endDate,
                (this.model.pagination.page - 1) * this.model.pagination.pageLimit, this.model.pagination.pageLimit,
                this.reverseSort, this.sortColumn, this.model.timezone)
                .then((data) => {
                    this.model.pagination.total = data.totalRecords;
                    this.model.countVariancesObj.results = data.results;
                    this.model.countVariancesObj.totalRecords = data.totalRecords;
                })
                .catch((err) => {
                    console.log(err);
                    if (err && err.data && err.data.message) {
                        this.Modal.errorModal(err.data.message);
                    }
                })
                .finally(() => {
                    this.model.loadCountVariances = false;
                    setTimeout(() => {
                        const el = document.getElementById('countVariancesSearch');
                        if (el) el.focus();
                    }, 100);
                })
        })
    }

    getStartDate() {
        return this.model.dateRangeOptions.startDate ? moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss') : null;
    }

    getEndDate() {
        return this.model.dateRangeOptions.endDate ? moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD HH:mm:ss') : null;
    }

    sortData(column) {
        this.reverseSort = (this.sortColumn == column) ? !this.reverseSort : false;
        this.sortColumn = column;
        this.loadData();
    }

    goToServiceHistory(locationId) {
        const obj = {
            locationId: locationId,
            isRedirected: true
        }
        this.DataCounter.setData(obj);
        this.$state.go('branchManagement.locations');
    }

    pageChange() {
        this.getCountVariances();
    }

    exportData() {
        const reportPrefix = `Count_Variances(${moment().format('YYYY-MM-DD_HH:mm')})`;
        const branchIds = this.model.selectedBranch.map(b => b.branchId);
        const startDate = this.getStartDate();
        const endDate = this.getEndDate();

        this.model.isExporting = true;

        this.CountVariancesService.exportCountVariances(this.model.searchText, branchIds, startDate, endDate, this.reverseSort, this.sortColumn, this.model.timezone)
            .then((data) => {
                this.downloadFile(reportPrefix, data.reportData);
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                this.model.isExporting = false;
            })
    }

    downloadFile(reportPrefix, reportData) {
        const fileName = reportPrefix.concat('.csv');
        const a = document.createElement("a");
        document.body.appendChild(a);
        const file = new Blob([reportData], { type: 'application/csv' });
        const fileURL = window.URL.createObjectURL(file);
        a.href = fileURL;
        a.download = fileName;
        a.click();
    }

    getComments(data) {
        this.Modal.confirm({
            header: this.$translate.instant('common.comment'),
            message: data.comment,
            callback: (({
                modal
            }) => {
                modal.close();
            }),
            negative: (({
                modal,
            }) => {
                modal.close();
            }),
            buttons: ['common.close'],
            type: 'success'
        })
    }

    goToUserTab(userId) {
        if (!userId) return;
        this.Navigation.goToUserTab(userId, null);
    }

    showReceipt(pickupImageName, trackingId) {
        if (!pickupImageName) return;
        const shipmentData = {
            pickupImageName: pickupImageName,
            trackingId: trackingId
        };
        this.Modal.atmResidualReceipt(shipmentData, ({ modal }) => {
        }, ({ modal }) => {
            modal.close();
        });
    }
}

export default CountVariancesController;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/count_variances/count_variances.controller.js